import { defineComponent as _defineComponent } from 'vue'
import TuiButton from '../../common/base/Button.vue';
import TuiSelect from '../../common/base/Select';
import TuiOption from '../../common/base/Option';
import Dialog from '../../common/base/Dialog';
import { TUIRole } from '@tencentcloud/tuiroom-engine-js';
import useEndControl from './useEndControlHooks';
import logger from '../../../utils/common/logger';
import { roomService } from '../../../services';


export default /*#__PURE__*/_defineComponent({
  __name: 'EndControlPC',
  setup(__props) {

const {
  t,
  isShowLeaveRoomDialog,
  roomStore,
  roomEngine,
  stopMeeting,
  cancel,
  selectedUser,
  DialogType,
  showEndDialogContent,
  logPrefix,
  title,
  showEndButtonContent,
  currentDialogType,
  visible,
  resetState,
  isMasterWithOneRemoteUser,
  isMasterWithRemoteUser,
  remoteEnteredUserList,
} = useEndControl();

function handleEndBtnClick() {
  stopMeeting();
}
function handleEndLeaveClick() {
  if (!roomStore.isMaster) {
    leaveRoom();
    return;
  }
  if (isMasterWithRemoteUser.value) {
    selectedUser.value = remoteEnteredUserList.value[0].userId;
    if (isMasterWithOneRemoteUser.value) {
      transferAndLeave();
      return;
    }
    currentDialogType.value = DialogType.TransferDialog;
  }
}

/**
 * Active room dismissal
 **/
async function dismissRoom() {
  try {
    logger.log(`${logPrefix}dismissRoom: enter`);
    resetState();
    await roomService.dismissRoom();
  } catch (error) {
    logger.error(`${logPrefix}dismissRoom error:`, error);
  }
}

/**
 * Leave the room voluntarily
 **/
async function leaveRoom() {
  // eslint-disable-line
  try {
    resetState();
    await roomService.leaveRoom();
  } catch (error) {
    logger.error(`${logPrefix}leaveRoom error:`, error);
  }
}

async function transferAndLeave() {
  if (!selectedUser.value) {
    return;
  }
  try {
    const userId = selectedUser.value;
    const changeUserRoleResponse = await roomEngine.instance?.changeUserRole({
      userId,
      userRole: TUIRole.kRoomOwner,
    });
    logger.log(`${logPrefix}transferAndLeave:`, changeUserRoleResponse);
    resetState();
    await roomService.leaveRoom();
  } catch (error) {
    logger.error(`${logPrefix}transferAndLeave error:`, error);
  }
}

return { __sfc: true,t, isShowLeaveRoomDialog, roomStore, roomEngine, stopMeeting, cancel, selectedUser, DialogType, showEndDialogContent, logPrefix, title, showEndButtonContent, currentDialogType, visible, resetState, isMasterWithOneRemoteUser, isMasterWithRemoteUser, remoteEnteredUserList, handleEndBtnClick, handleEndLeaveClick, dismissRoom, leaveRoom, transferAndLeave, TuiButton, TuiSelect, TuiOption, Dialog }
}

})